// React for Website

import React, { useState, useEffect } from "react";
//outsource
import { Row, Col, Modal, Button, Space, Divider } from "antd";
import { AiFillGift } from "react-icons/ai";
import moment from "moment";

//redux
import { useDispatch, useSelector } from "react-redux";
import { getHistoryRedeem } from "../../../store/voucher/voucher.action";
import { getAllUser } from "../../../store/user/user.action";
import { allSelector } from "../../../store/user/user.selector";

//components

const DialogVoucherDetail = ({ data, open, setOpen }) => {
  // -------------------------- VAR --------------------------
  console.log("data", data);
  const code = data?.code || "";
  const source = data?.source || "";
  const color = renderIconColor(data);
  const createAt =
    data?.createAt &&
    moment(data?.createAt?.toDate()).format("DD MMM YYYY hh:mm a");

  const infos = [
    { key: 1, title: "Initial Amount", value: data?.balance || 0 },
    {
      key: 2,
      title: "Available Balance",
      value: data?.balance - data?.spent || 0,
    },
    {
      key: 3,
      title: "Issued By",
      value: `${data?.senderFirstName} ${data?.senderLastName}`,
    },
    { key: 4, title: "Customer Email", value: data?.senderEmail || "" },
    { key: 5, title: "Customer Mobile", value: data?.senderPhone || "#N/A" },
    { key: 6, title: "Receiver Email", value: data?.email || "" },
  ];

  // -------------------------- STATE --------------------------
  const [codes, setCodes] = useState(null);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const user = useSelector(allSelector);

  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (code !== "") {
      dispatch(
        getHistoryRedeem({ code }, (data) => {
          if (user) {
            const newData = data?.map((item) => {
              const target = user?.find((row) => row?.id === item?.uid);
              const name = `${target?.lastName} ${target?.firstName}`;
              return {
                ...item,
                name,
              };
            });
            setCodes(newData);
          }
        })
      );
    }
  }, [code]);

  //snap All User
  useEffect(() => {
    dispatch(getAllUser());
  }, [dispatch]);
  // -------------------------- RENDER --------------------------
  const renderHeader = () => {
    return (
      <Row
        className="header-modal-detail"
        style={{ display: "flex", alignItems: "center" }}
      >
        <Col align="left" span={8}>
          <Space>
            <AiFillGift color={color} size={40} />
            <span style={{ color: color, fontSize: 15 }}>
              {source?.toUpperCase()}
            </span>
          </Space>
        </Col>
        <Col align="center" span={8}>
          <b style={{ fontSize: 15 }}>Voucher {code}</b>
        </Col>
        <Col align="right" span={8}>
          (Purchased on {createAt})
        </Col>
      </Row>
    );
  };

  const renderBody = () => {
    return (
      <Row gutter={[30, 30]}>
        {infos?.map((item, index) => {
          const color =
            index === 0 ? "purple" : item?.value === 0 ? "red" : "black";
          const label =
            index === 0 || index === 1 ? `$${item?.value}` : item?.value;
          return (
            <Col span={8} key={item?.key}>
              <div style={{ fontWeight: "bold" }}>{item?.title}</div>
              <div style={{ color }}>{label}</div>
            </Col>
          );
        })}
      </Row>
    );
  };

  const renderFooter = () => {
    return (
      <Col align="center" span={24}>
        <Button
          style={{ width: 150 }}
          type="primary"
          onClick={() => setOpen(false)}
        >
          OK
        </Button>
      </Col>
    );
  };

  const renderHistory = () => {
    if (codes) {
      const sortes = codes?.sort((a, b) => b.createAt - a.createAt);
      return (
        <ol style={{ paddingLeft: 20 }}>
          {sortes?.map((item) => {
            const name = item?.name || "";
            const amount = item?.amount || "";
            const createAt =
              item?.createAt &&
              moment(item?.createAt?.toDate()).format("DD MMM YYYY hh:mm a");
            const label = ` accepted the redemption of $${amount} on ${createAt}`;
            return (
              <li style={{ margin: "10px 0px" }} key={item?.id}>
                <strong>{name}</strong>
                {label}
              </li>
            );
          })}
        </ol>
      );
    }
  };

  const renderEnd = () => {
    if (codes?.length === 0) {
      return <div>No redemption history</div>;
    }
  };

  // -------------------------- MAIN --------------------------
  return (
    <Modal
      title={null}
      visible={open}
      onCancel={() => setOpen(false)}
      footer={renderFooter()}
      closable={false}
      width={800}
      centered
    >
      {renderHeader()}
      <Divider style={{ margin: "5px 0px 10px" }} />
      {renderBody()}
      <Divider>
        <h4>History</h4>
      </Divider>
      {renderHistory()}
      {renderEnd()}
    </Modal>
  );
};

export default DialogVoucherDetail;

const renderIconColor = (item) => {
  switch (item?.source) {
    case "website":
      return "blue";

    case "admin":
      return "purple";
    case "pos":
      return "#65e142";

    default:
      return "black";
  }
};
